/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { createContext, useContext, useReducer } from 'react';
import filterScope1Reducer from './FilterScope1Reducer';
import { IAny } from '../../components/DashboardKPIWidgets/IEnergyManagementProps';

export interface IFilterScope1State {
  showModal: boolean;
  saveFilterData: IAny;
  saveErrorData?: IAny;
  subscriptionDetails?: IAny;
}

const initialState: IFilterScope1State = {
  showModal: false,
  saveFilterData: [],
  saveErrorData: [],
  subscriptionDetails: ''
};

export const FilterScope1Context = createContext<IAny>(initialState);

export const FilterScope1Provider: React.FC<{}> = ({ children }) => {
  const [state, dispatch] = useReducer(filterScope1Reducer, initialState);

  const value: IAny = [state, dispatch];

  return (
    <FilterScope1Context.Provider value={value}>
      {children}
    </FilterScope1Context.Provider>
  );
};

export const useFilterScope1Context = () => useContext(FilterScope1Context);
